import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Star,
  Quote,
  ChevronLeft,
  ChevronRight,
  ArrowUpRight,
} from "lucide-react";

export default function Hero() {
  const navigate = useNavigate();

  // =========================================
  // FOOD SLIDER IMAGES
  // =========================================
  const images = [
    "/food1.jpg",
    "/food2.jpg",
    "/food3.jpg",
    "/food4.jpg",
    "/food5.jpg",
    "/food6.jpg",
  ];

  const sliderImages = [...images, ...images];

  // =========================================
  // REVIEWS
  // =========================================
  const reviews = [
    {
      id: 1,
      name: "Sarah Mitchell",
      role: "Happy Guest",
      image: "/customer1.jpeg",
      review:
        "Capeesh is such a beautiful experience. The food was absolutely incredible, the atmosphere was warm and inviting, and every detail felt thoughtfully designed. We will definitely be coming back!",
    },
    {
      id: 2,
      name: "Michael Anderson",
      role: "Food Lover",
      image: "/customer2.jpeg",
      review:
        "One of the best dining experiences we have had in a long time. The food was fresh, creative and full of flavour. The staff were fantastic and the entire evening felt truly special.",
    },
    {
      id: 3,
      name: "Emily Thompson",
      role: "Regular Guest",
      image: "/customer3.jpeg",
      review:
        "Capeesh has quickly become one of our favourite places to eat. Amazing food, great drinks and such a relaxed atmosphere. It is the perfect place for a casual dinner or a special night out.",
    },
    {
      id: 4,
      name: "David Wilson",
      role: "Happy Customer",
      image: "/customer4.jpeg",
      review:
        "Absolutely loved our visit to Capeesh. Everything from the presentation of the food to the service was exceptional. A wonderful restaurant with a unique personality and an unforgettable experience.",
    },
  ];

  const [currentReview, setCurrentReview] = useState(0);

  // =========================================
  // AUTO CHANGE REVIEWS
  // =========================================
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentReview((prev) => (prev + 1) % reviews.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [reviews.length]);

  const nextReview = () => {
    setCurrentReview((prev) => (prev + 1) % reviews.length);
  };

  const previousReview = () => {
    setCurrentReview((prev) => (prev - 1 + reviews.length) % reviews.length);
  };

  const activeReview = reviews[currentReview];

  // const OpenTableBadge = ({ people = 2 }) => {  
  //   const today = new Date();
  //    const currentDate = today.toISOString().split("T")[0]; 
  //     const dateTime = `${currentDate}T19:00`;

  return (
    <>
      {/* =========================================================
          HERO SECTION
      ========================================================= */}
      <section className="w-full overflow-hidden bg-white">
        <div className="grid min-h-0 grid-cols-1 lg:min-h-screen lg:grid-cols-2">
          {/* =====================================================
              VIDEO
          ===================================================== */}
          <div
            className="
              relative
              h-[52vh]
              min-h-[320px]
              w-full
              overflow-hidden
              sm:h-[58vh]
              md:h-[62vh]
              lg:h-screen
            "
          >
            <video
              autoPlay
              loop
              muted
              playsInline
              preload="metadata"
              className="
                absolute
                inset-0
                h-full
                w-full
                object-cover
                object-center
              "
            >
              <source src="/homepage.MP4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>

            <div className="absolute inset-0 bg-black/10" />
          </div>

          {/* =====================================================
              HERO CONTENT
          ===================================================== */}
          <div className="flex w-full items-center bg-white">
            <div
              className="
                mx-auto
                w-full
                max-w-[900px]
                px-5
                py-10
                sm:px-8
                sm:py-12
                md:px-10
                md:py-16
                lg:px-12
                lg:py-16
                xl:px-16
                2xl:px-20
              "
            >
              {/* =================================================
                  TITLE + OPENTABLE AWARD
              ================================================= */}
              <div
                className="
                  flex
                  flex-col
                  gap-10
                  md:gap-8
                  lg:grid
                  lg:grid-cols-[minmax(0,1fr)_auto]
                  lg:items-center
                  lg:gap-8
                  xl:gap-12
                "
              >
                {/* =================================================
                    ANIMATED TITLES
                ================================================= */}
                <div className="hero-title-group flex min-w-0 flex-col gap-2 sm:gap-3 md:gap-4">
                  {/* NO THEME */}
                  <h1
                    className="
                      hero-motion-title
                      hero-title-one
                      m-0
                      break-words
                      text-[clamp(36px,10vw,62px)]
                      font-normal
                      leading-[0.92]
                      tracking-[-0.045em]
                      text-[#030303]
                      sm:text-[clamp(42px,7vw,62px)]
                    "
                  >
                    <span>NO THEME!</span>
                  </h1>

                  {/* NO BOUNDARIES */}
                  <h1
                    className="
                      hero-motion-title
                      hero-title-two
                      m-0
                      break-words
                      text-[clamp(36px,10vw,62px)]
                      font-normal
                      leading-[0.92]
                      tracking-[-0.045em]
                      text-[#030303]
                      sm:text-[clamp(42px,7vw,62px)]
                    "
                  >
                    <span>NO BOUNDARIES!</span>
                  </h1>

                  {/* NO RULES */}
                  <h1
                    className="
                      hero-motion-title
                      hero-title-three
                      m-0
                      break-words
                      text-[clamp(36px,10vw,62px)]
                      font-normal
                      leading-[0.92]
                      tracking-[-0.045em]
                      text-[#030303]
                      sm:text-[clamp(42px,7vw,62px)]
                    "
                  >
                    <span>NO RULES!</span>
                  </h1>
                </div>

                {/* =================================================
                    OPENTABLE CIRCLE
                ================================================= */}
                <div className="flex justify-center lg:justify-end">
  <a
    href="https://www.opentable.ca/booking/restref/availability?rid=1080589&lang=en-CA&color=1&dark=false"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Book a table on OpenTable"
    className="block cursor-pointer transition-transform duration-300 hover:scale-105"
  >
    <div
      className="
        flex
        h-40
        w-40
        shrink-0
        items-center
        justify-center
        rounded-full
        bg-[#f50046]
        text-center
        text-white
        sm:h-48
        sm:w-48
        md:h-52
        md:w-52
        lg:h-56
        lg:w-56
        xl:h-64
        xl:w-64
        2xl:h-[275px]
        2xl:w-[275px]
      "
    >
      <div className="flex flex-col items-center">

        <p
          className="
            flex
            items-center
            gap-1.5
            text-[10px]
            font-semibold
            sm:text-xs
            md:text-sm
            lg:text-base
          "
        >
          <span className="text-base sm:text-lg">•</span>

          <span
            className="
              flex
              h-5
              w-5
              items-center
              justify-center
              rounded-full
              bg-white
              text-[10px]
              text-[#f50046]
              sm:h-7
              sm:w-7
              sm:text-xs
            "
          >
            ●
          </span>

          <span>OpenTable</span>
        </p>

        <p
          className="
            mt-2
            font-serif
            text-2xl
            leading-[0.9]
            sm:mt-3
            sm:text-3xl
            md:text-4xl
            lg:text-5xl
            xl:text-[52px]
          "
        >
          Diners’
          <br />
          Choice
        </p>

        <p
          className="
            mt-3
            text-base
            font-bold
            tracking-wide
            sm:text-lg
            md:text-xl
            lg:text-2xl
          "
        >
          2026
        </p>

      </div>
    </div>
  </a>
</div>
              </div>

              {/* =================================================
                  DESCRIPTION
              ================================================= */}
              <div
                className="
                  mt-10
                  max-w-[650px]
                  sm:mt-12
                  md:mt-14
                  lg:mt-16
                  xl:mt-20
                "
              >
                <p
                  className="
                    font-serif
                    text-base
                    leading-relaxed
                    text-black
                    sm:text-lg
                    md:text-xl
                    lg:text-2xl
                  "
                >
                  Proudly Canadian{" "}
                  <span className="font-bold italic">
                    with a little bit of everything.
                  </span>
                </p>

                <ul
                  className="
                    mt-5
                    space-y-1.5
                    font-serif
                    text-base
                    text-black
                    sm:mt-6
                    sm:text-lg
                    md:text-xl
                    lg:text-2xl
                  "
                >
                  <li>• Indoor Dining</li>
                  <li>• Takeout</li>
                  <li>• 2 Riverside Patios</li>
                </ul>
              </div>

              {/* =================================================
                  BUTTONS
              ================================================= */}
              <div
                className="
                  mt-8
                  flex
                  w-full
                  flex-col
                  gap-3
                  sm:mt-10
                  sm:flex-row
                  sm:gap-4
                  md:mt-12
                "
              >
                <button
                  onClick={() => navigate("/menu")}
                  className="
                    w-full
                    border
                    border-black
                    bg-white
                    px-6
                    py-3.5
                    text-xs
                    font-semibold
                    uppercase
                    tracking-[0.15em]
                    text-black
                    transition
                    duration-300
                    hover:bg-black
                    hover:text-white
                    active:bg-black
                    active:text-white
                    sm:w-auto
                    sm:min-w-[190px]
                    sm:px-7
                    sm:py-4
                    md:min-w-[200px]
                    lg:py-5
                  "
                >
                  Explore the Menu
                </button>

                <button
                  onClick={() => navigate("/reservation")}
                  className="
                    w-full
                    border
                    border-black
                    bg-white
                    px-6
                    py-3.5
                    text-xs
                    font-semibold
                    uppercase
                    tracking-[0.15em]
                    text-black
                    transition
                    duration-300
                    hover:bg-black
                    hover:text-white
                    active:bg-black
                    active:text-white
                    sm:w-auto
                    sm:min-w-[190px]
                    sm:px-7
                    sm:py-4
                    md:min-w-[200px]
                    lg:py-5
                  "
                >
                  Reserve a Table
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* =========================================================
          INFINITE FOOD SLIDER
      ========================================================= */}
      <section
        className="
          w-full
          overflow-hidden
          bg-white
          py-6
          sm:py-8
          md:py-10
          lg:py-14
          xl:py-16
        "
      >
        <div className="w-full overflow-hidden">
          <div
            className="
              flex
              w-max
              animate-[infiniteSlide_30s_linear_infinite]
              hover:[animation-play-state:paused]
            "
          >
            {sliderImages.map((image, index) => (
              <div
                key={index}
                className="
                  w-[72vw]
                  flex-shrink-0
                  px-1.5
                  sm:w-[50vw]
                  sm:px-2
                  md:w-[38vw]
                  md:px-2.5
                  lg:w-[28vw]
                  lg:px-3
                  xl:w-[25vw]
                "
              >
                <div className="aspect-square w-full overflow-hidden">
                  <img
                    src={image}
                    alt={`Capeesh food ${(index % images.length) + 1}`}
                    loading="lazy"
                    className="
                      h-full
                      w-full
                      object-cover
                      transition-transform
                      duration-500
                      hover:scale-105
                    "
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* =========================================================
          REVIEWS SECTION
      ========================================================= */}
      <section
        className="
          relative
          w-full
          overflow-hidden
          bg-white
          py-16
          sm:py-20
          md:py-24
          lg:py-28
          xl:py-32
        "
      >
        <div
          className="
            pointer-events-none
            absolute
            -left-32
            top-20
            h-64
            w-64
            rounded-full
            bg-[#f7f5ef]
            sm:-left-40
            sm:h-80
            sm:w-80
          "
        />

        <div
          className="
            pointer-events-none
            absolute
            -right-32
            bottom-0
            h-72
            w-72
            rounded-full
            bg-[#f7f5ef]
            sm:-right-40
            sm:h-96
            sm:w-96
          "
        />

        <div
          className="
            relative
            mx-auto
            w-full
            max-w-7xl
            px-5
            sm:px-8
            md:px-10
            lg:px-12
            xl:px-16
          "
        >
          {/* =====================================================
              SECTION HEADING
          ===================================================== */}
          <div
            className="
              mb-10
              text-center
              sm:mb-12
              md:mb-14
              lg:mb-16
            "
          >
            <p
              className="
                mb-3
                text-[10px]
                font-bold
                uppercase
                tracking-[0.28em]
                text-[#b08d27]
                sm:mb-4
                sm:text-xs
                sm:tracking-[0.35em]
              "
            >
              The Capeesh Experience
            </p>

            <h2
              className="
                font-serif
                text-3xl
                font-medium
                tracking-tight
                text-black
                sm:text-4xl
                md:text-5xl
                lg:text-6xl
              "
            >
              Loved by our guests
            </h2>

            <div className="mx-auto mt-5 h-[2px] w-14 bg-[#d4af37] sm:mt-6 sm:w-16" />

            <p
              className="
                mx-auto
                mt-5
                max-w-2xl
                text-sm
                leading-6
                text-gray-500
                sm:mt-6
                sm:text-base
                sm:leading-7
              "
            >
              Great food is only part of the experience. Here is what our guests
              have to say about their time at Capeesh.
            </p>
          </div>

          {/* =====================================================
              REVIEW CONTENT
          ===================================================== */}
          <div
            className="
              grid
              items-center
              gap-10
              lg:grid-cols-12
              lg:gap-12
              xl:gap-16
            "
          >
            {/* REVIEW IMAGE */}
            <div className="relative lg:col-span-5">
              <div className="relative mx-auto w-full max-w-md">
                <div className="overflow-hidden rounded-sm">
                  <img
                    src="/food1.jpg"
                    alt="Capeesh food"
                    loading="lazy"
                    className="
                      h-[360px]
                      w-full
                      object-cover
                      transition-transform
                      duration-700
                      hover:scale-105
                      sm:h-[450px]
                      md:h-[500px]
                      lg:h-[520px]
                      xl:h-[560px]
                    "
                  />
                </div>

                <div
                  className="
                    pointer-events-none
                    absolute
                    -bottom-4
                    -left-4
                    -z-0
                    h-full
                    w-full
                    border
                    border-[#d4af37]
                    sm:-bottom-5
                    sm:-left-5
                  "
                />

                <div
                  className="
                    absolute
                    -bottom-8
                    -right-5
                    hidden
                    h-32
                    w-32
                    overflow-hidden
                    border-4
                    border-white
                    shadow-xl
                    sm:block
                    sm:h-36
                    sm:w-36
                    lg:-right-8
                    lg:h-40
                    lg:w-40
                  "
                >
                  <img
                    src="drinkin.jpg"
                    alt="Capeesh dish"
                    loading="lazy"
                    className="h-full w-full object-cover"
                  />
                </div>

                <div
                  className="
                    absolute
                    -left-2
                    top-6
                    bg-black
                    px-4
                    py-4
                    text-white
                    shadow-xl
                    sm:-left-6
                    sm:px-6
                    sm:py-5
                    lg:-left-10
                  "
                >
                  <p className="font-serif text-xl italic sm:text-2xl">
                    Capeesh
                  </p>

                  <p
                    className="
                      mt-1
                      text-[8px]
                      uppercase
                      tracking-[0.25em]
                      text-[#d4af37]
                      sm:text-[9px]
                      sm:tracking-[0.3em]
                    "
                  >
                    Craft Kitchen & Cellar
                  </p>
                </div>
              </div>
            </div>

            {/* REVIEW CARD */}
            <div className="w-full lg:col-span-7">
              <div className="relative">
                <div
                  className="
                    pointer-events-none
                    absolute
                    -top-8
                    left-0
                    text-[#d4af37]/20
                    sm:-top-10
                  "
                >
                  <Quote
                    size={70}
                    strokeWidth={1}
                    className="sm:h-[100px] sm:w-[100px]"
                  />
                </div>

                <div
                  className="
                    relative
                    bg-[#f7f7f5]
                    p-6
                    sm:p-8
                    md:p-10
                    lg:p-12
                    xl:p-14
                  "
                >
                  <div className="mb-6 flex items-center justify-between sm:mb-8">
                    <div>
                      <p
                        className="
                          text-[10px]
                          font-bold
                          uppercase
                          tracking-[0.25em]
                          text-[#b08d27]
                          sm:text-xs
                          sm:tracking-[0.3em]
                        "
                      >
                        Guest Reviews
                      </p>

                      <div className="mt-2 h-[2px] w-10 bg-[#d4af37] sm:mt-3 sm:w-12" />
                    </div>
                  </div>

                  <div
                    key={activeReview.id}
                    className="animate-[fadeIn_0.6s_ease-in-out]"
                  >
                    <div className="mb-5 flex gap-1 sm:mb-7">
                      {[...Array(5)].map((_, index) => (
                        <Star
                          key={index}
                          size={16}
                          fill="#d4af37"
                          strokeWidth={0}
                          className="text-[#d4af37] sm:h-[17px] sm:w-[17px]"
                        />
                      ))}
                    </div>

                    <blockquote
                      className="
                        max-w-2xl
                        font-serif
                        text-xl
                        leading-relaxed
                        text-gray-800
                        sm:text-2xl
                        md:text-3xl
                        lg:text-[30px]
                        xl:text-[32px]
                      "
                    >
                      "{activeReview.review}"
                    </blockquote>

                    <div
                      className="
                        mt-8
                        flex
                        flex-col
                        gap-5
                        border-t
                        border-gray-200
                        pt-6
                        sm:mt-10
                        sm:flex-row
                        sm:items-center
                        sm:justify-between
                        sm:gap-4
                        sm:pt-7
                      "
                    >
                      <div className="flex items-center gap-3 sm:gap-4">
                        <div
                          className="
                            h-12
                            w-12
                            shrink-0
                            overflow-hidden
                            rounded-full
                            border-2
                            border-white
                            shadow-md
                            sm:h-14
                            sm:w-14
                          "
                        >
                          <img
                            src={activeReview.image}
                            alt={activeReview.name}
                            loading="lazy"
                            className="h-full w-full object-cover"
                          />
                        </div>

                        <div>
                          <h4 className="text-sm font-semibold text-black sm:text-base">
                            {activeReview.name}
                          </h4>

                          <p
                            className="
                              mt-1
                              text-[9px]
                              uppercase
                              tracking-[0.15em]
                              text-[#b08d27]
                              sm:text-xs
                              sm:tracking-[0.2em]
                            "
                          >
                            {activeReview.role}
                          </p>
                        </div>
                      </div>

                      <div className="hidden sm:block">
                        <ArrowUpRight
                          size={28}
                          strokeWidth={1.5}
                          className="text-gray-400"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="mt-8 flex items-center justify-between sm:mt-10">
                    <div className="flex gap-2">
                      <button
                        onClick={previousReview}
                        aria-label="Previous review"
                        className="
                          flex
                          h-10
                          w-10
                          items-center
                          justify-center
                          border
                          border-gray-300
                          text-black
                          transition-all
                          duration-300
                          hover:border-black
                          hover:bg-black
                          hover:text-white
                          sm:h-11
                          sm:w-11
                        "
                      >
                        <ChevronLeft size={19} />
                      </button>

                      <button
                        onClick={nextReview}
                        aria-label="Next review"
                        className="
                          flex
                          h-10
                          w-10
                          items-center
                          justify-center
                          border
                          border-gray-300
                          text-black
                          transition-all
                          duration-300
                          hover:border-black
                          hover:bg-black
                          hover:text-white
                          sm:h-11
                          sm:w-11
                        "
                      >
                        <ChevronRight size={19} />
                      </button>
                    </div>
                  </div>
                </div>

                <div
                  className="
                    absolute
                    -bottom-2
                    right-5
                    h-5
                    w-20
                    bg-[#d4af37]
                    sm:-bottom-3
                    sm:right-8
                    sm:h-6
                    sm:w-24
                  "
                />
              </div>
            </div>
          </div>
        </div>

        {/* =========================================================
            ALL ANIMATIONS
        ========================================================= */}
        <style>{`

          /* =========================================
             HERO TITLE ANIMATION
          ========================================= */

          .hero-title-group {
            perspective: 900px;
          }

          .hero-motion-title {
            position: relative;
            overflow: hidden;
            width: fit-content;
            max-width: 100%;
            cursor: default;
          }

          .hero-motion-title span {
            display: inline-block;
            transform: translate3d(-110%, 0, 0);
            opacity: 0;
            animation:
              heroTextReveal 1s cubic-bezier(0.22, 1, 0.36, 1) forwards,
              heroTextFloat 4s ease-in-out infinite;
            will-change: transform, opacity;
          }

          /* FIRST LINE */
          .hero-title-one span {
            animation-delay: 0.1s, 1.4s;
          }

          /* SECOND LINE */
          .hero-title-two span {
            animation-delay: 0.3s, 1.7s;
          }

          /* THIRD LINE */
          .hero-title-three span {
            animation-delay: 0.5s, 2s;
          }

          /* SLIDING SHINE */
          .hero-motion-title::after {
            content: "";
            position: absolute;
            top: 0;
            left: -120%;
            width: 55%;
            height: 100%;
            background: linear-gradient(
              90deg,
              transparent,
              rgba(245, 0, 70, 0.16),
              transparent
            );
            transform: skewX(-20deg);
            animation: heroShine 5s ease-in-out infinite;
            pointer-events: none;
          }

          /* HOVER EFFECT */
          .hero-motion-title:hover span {
            transform: translateX(8px);
            letter-spacing: 0.01em;
            transition:
              transform 0.5s cubic-bezier(0.22, 1, 0.36, 1),
              letter-spacing 0.5s ease;
          }

          .hero-motion-title:hover {
            color: #f50046;
            transition: color 0.4s ease;
          }

          /* =========================================
             TEXT REVEAL
          ========================================= */
          @keyframes heroTextReveal {
            0% {
              transform: translate3d(-110%, 0, 0);
              opacity: 0;
            }

            60% {
              opacity: 1;
            }

            100% {
              transform: translate3d(0, 0, 0);
              opacity: 1;
            }
          }

          /* =========================================
             SUBTLE FLOATING MOTION
          ========================================= */
          @keyframes heroTextFloat {
            0% {
              transform: translateY(0);
            }

            50% {
              transform: translateY(-4px);
            }

            100% {
              transform: translateY(0);
            }
          }

          /* =========================================
             SHINE EFFECT
          ========================================= */
          @keyframes heroShine {
            0% {
              left: -120%;
              opacity: 0;
            }

            15% {
              opacity: 1;
            }

            35% {
              left: 130%;
              opacity: 0;
            }

            100% {
              left: 130%;
              opacity: 0;
            }
          }

          /* =========================================
             REVIEW FADE
          ========================================= */
          @keyframes fadeIn {
            from {
              opacity: 0;
              transform: translateY(12px);
            }

            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          /* =========================================
             INFINITE FOOD SLIDER
          ========================================= */
          @keyframes infiniteSlide {
            from {
              transform: translateX(0);
            }

            to {
              transform: translateX(-50%);
            }
          }

          /* =========================================
             TABLET
          ========================================= */
          @media (max-width: 1023px) {

            .hero-motion-title span {
              animation-duration:
                0.9s,
                4.5s;
            }

          }

          /* =========================================
             MOBILE
          ========================================= */
          @media (max-width: 640px) {

            .hero-title-group {
              perspective: 600px;
            }

            .hero-motion-title {
              width: 100%;
              overflow: visible;
            }

            .hero-motion-title span {
              animation:
                heroTextRevealMobile
                0.85s
                cubic-bezier(0.22, 1, 0.36, 1)
                forwards,
                heroTextFloatMobile
                4.5s
                ease-in-out
                infinite;
            }

            .hero-title-one span {
              animation-delay: 0.1s, 1.2s;
            }

            .hero-title-two span {
              animation-delay: 0.25s, 1.5s;
            }

            .hero-title-three span {
              animation-delay: 0.4s, 1.8s;
            }

            .hero-motion-title:hover span {
              transform: translateX(4px);
              letter-spacing: 0;
            }

            .hero-motion-title::after {
              width: 70%;
              animation-duration: 6s;
            }

          }

          @keyframes heroTextRevealMobile {
            0% {
              transform: translate3d(-80px, 0, 0);
              opacity: 0;
            }

            100% {
              transform: translate3d(0, 0, 0);
              opacity: 1;
            }
          }

          @keyframes heroTextFloatMobile {
            0% {
              transform: translateY(0);
            }

            50% {
              transform: translateY(-3px);
            }

            100% {
              transform: translateY(0);
            }
          }

          /* =========================================
             REDUCED MOTION ACCESSIBILITY
          ========================================= */
          @media (prefers-reduced-motion: reduce) {

            .hero-motion-title span,
            .hero-motion-title::after {
              animation: none !important;
              transform: none !important;
              opacity: 1 !important;
            }

            .animate-\\[infiniteSlide_30s_linear_infinite\\] {
              animation: none !important;
            }

          }

        `}</style>
      </section>
    </>
  );
}
